export default __webpack_public_path__ + "static/media/shapes.035ff697.JPG";